import { v4 as uuid } from 'uuid'

import {
  type MakeswiftPageSnapshot,
  type MakeswiftPageDocument,
  type MakeswiftComponentSnapshot,
} from '../client'
import { CacheData } from '../api/api-resources-client'
import { type Element, type ElementData } from '../state/read-only-state'
import { MakeswiftComponentType } from '../components/builtin/constants'

export function createRootComponent(elements: Element[], rootId?: string) {
  return {
    key: rootId ?? uuid(),
    type: MakeswiftComponentType.Root,
    props: {
      children: {
        columns: [
          {
            deviceId: 'desktop',
            value: {
              count: 12,
              spans: elements?.map(() => [12]),
            },
          },
        ],
        elements,
      },
    },
  }
}

const isDocument = (
  elementOrDocument: Element | MakeswiftPageDocument,
): elementOrDocument is MakeswiftPageDocument =>
  'snippets' in elementOrDocument ||
  'fonts' in elementOrDocument ||
  'meta' in elementOrDocument ||
  'seo' in elementOrDocument

export function createMakeswiftPageSnapshot(
  elementOrDocument: Element | MakeswiftPageDocument,
  {
    cacheData = {},
    locale = null,
  }: { cacheData?: Partial<MakeswiftPageSnapshot['cacheData']>; locale?: string | null } = {},
): MakeswiftPageSnapshot {
  return {
    document: isDocument(elementOrDocument)
      ? elementOrDocument
      : {
          id: 'test-page-id',
          site: { id: 'test-site-id' },
          data: elementOrDocument,
          snippets: [],
          fonts: [],
          meta: {},
          seo: {},
          localizedPages: [],
          locale,
        },
    cacheData: {
      ...CacheData.empty(),
      ...cacheData,
    },
  }
}

export function createMakeswiftComponentSnapshot(
  elementData: ElementData | null,
  {
    cacheData = {},
    locale = null,
  }: { cacheData?: Partial<MakeswiftComponentSnapshot['cacheData']>; locale?: string | null } = {},
): MakeswiftComponentSnapshot {
  return {
    key: uuid(),
    document: {
      id: 'test-component-id',
      name: 'Test Component Document',
      siteId: 'test-site-id',
      data: elementData,
      inheritsFromParent: false,
      locale,
    },
    meta: {
      allowLocaleFallback: false,
      requestedLocale: locale,
    },
    cacheData: {
      ...CacheData.empty(),
      ...cacheData,
    },
  }
}
